export default __webpack_public_path__ + "static/media/entertainment.3bad2db0.png";